import React, { useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { stripAllHtmlAndEncodedTags } from "../../utils";

const TextEditor = (props: any) => {
  const quillRef = useRef<ReactQuill>(null);

  const modules = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
    ],
  };

  const handlePaste = (e: React.ClipboardEvent) => {
    e.preventDefault();

    const clipboardData = e.clipboardData;
    if (!clipboardData) return;

    const html =
      clipboardData.getData("text/html") || clipboardData.getData("text/plain");

    // Sanitize but KEEP allowed formatting tags
    const cleanedHtml = stripAllHtmlAndEncodedTags(html);

    const quill = quillRef.current?.getEditor();
    if (!quill) return;

    const range = quill.getSelection(true);

    // ✅ Paste as HTML so formatting survives
    quill.clipboard.dangerouslyPasteHTML(
      range?.index ?? quill.getLength(),
      cleanedHtml
    );
  };

  return (
    <div onPaste={handlePaste}>
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={props.inputData}
        onChange={props.onChange}
        modules={modules}
        formats={["bold", "italic", "underline", "list", "bullet"]}
      />
    </div>
  );
};

export default TextEditor;
